import { render, staticRenderFns } from "./CommercialTermsMenu.vue?vue&type=template&id=422b19fc"
import script from "./CommercialTermsMenu.vue?vue&type=script&lang=js"
export * from "./CommercialTermsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports